var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var card = function (skin) {
    return {
        MuiCard: {
            defaultProps: __assign({}, (skin === 'bordered' && {
                variant: 'outlined'
            })),
            styleOverrides: {
                root: function (_a) {
                    var ownerState = _a.ownerState;
                    return (__assign({}, (ownerState.variant !== 'outlined'
                        ? {
                            boxShadow: 'var(--mui-customShadows-md)'
                        }
                        : { backgroundColor: '#FFFFFF' })));
                }
            }
        },
        MuiCardHeader: {
            styleOverrides: {
                root: function (_a) {
                    var theme = _a.theme;
                    return ({
                        padding: theme.spacing(5),
                        '& + .MuiCardContent-root, & + .MuiCardActions-root': {
                            paddingBlockStart: 0
                        },
                        '& + .MuiCollapse-root .MuiCardContent-root:first-child, & + .MuiCollapse-root .MuiCardActions-root:first-child': {
                            paddingBlockStart: 0
                        }
                    });
                },
                subheader: function (_a) {
                    var theme = _a.theme;
                    return (__assign(__assign({}, theme.typography.subtitle1), { color: 'rgb(var(--mui-palette-text-primaryChannel) / 0.55)' }));
                },
                action: function (_a) {
                    var theme = _a.theme;
                    return (__assign(__assign({}, theme.typography.body1), { color: 'var(--mui-palette-text-disabled)', marginBlock: 0, marginInlineEnd: 0, '& .MuiIconButton-root': {
                            color: 'inherit'
                        } }));
                }
            }
        },
        MuiCardContent: {
            styleOverrides: {
                root: function (_a) {
                    var theme = _a.theme;
                    return ({
                        padding: theme.spacing(5),
                        '&:last-child': {
                            paddingBlockEnd: theme.spacing(5)
                        },
                        '& + .MuiCardHeader-root, & + .MuiCardContent-root, & + .MuiCardActions-root': {
                            paddingBlockStart: 0
                        },
                        '& + .MuiCollapse-root .MuiCardHeader-root:first-child, & + .MuiCollapse-root .MuiCardContent-root:first-child, & + .MuiCollapse-root .MuiCardActions-root:first-child': {
                            paddingBlockStart: 0
                        }
                    });
                }
            }
        },
        MuiCardActions: {
            styleOverrides: {
                root: function (_a) {
                    var theme = _a.theme;
                    return ({
                        padding: theme.spacing(5),
                        '&:where(.card-actions-dense)': {
                            padding: theme.spacing(2.5),
                            '& .MuiButton-text': {
                                paddingInline: theme.spacing(2.5)
                            }
                        },
                        '& + .MuiCardHeader-root, & + .MuiCardContent-root, & + .MuiCardActions-root': {
                            paddingBlockStart: 0
                        },
                        '& + .MuiCollapse-root .MuiCardHeader-root:first-child, & + .MuiCollapse-root .MuiCardContent-root:first-child, & + .MuiCollapse-root .MuiCardActions-root:first-child': {
                            paddingBlockStart: 0
                        }
                    });
                }
            }
        }
    };
};
export default card;
